import { render, staticRenderFns } from "./allBrandCarModel.vue?vue&type=template&id=1ff18150&scoped=true"
import script from "./allBrandCarModel.vue?vue&type=script&lang=js"
export * from "./allBrandCarModel.vue?vue&type=script&lang=js"
import style0 from "./allBrandCarModel.vue?vue&type=style&index=0&id=1ff18150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff18150",
  null
  
)

export default component.exports